const lsNavList = [
    // 基础模块
    {
        id: 0,
        name: "概况",
        img: require('@/assets/img/bbNav.png'),
        act_img: require('@/assets/img/actBbNav.png'),
        path: '/BusinessOverview',
        authId: 'gk',

        data: [
            //   {
            //   id: 100,
            //   name: '概况',
            //   children: [{
            //     id: 100001,
            //     path: '/BusinessOverview',
            //     name: '概况',
            //     navTitle: "概况 / 概况"
            //   }]
            // }
        ]
    },
    {
        id: 10,
        name: "基础",
        img: require('@/assets/img//nav/lsNavIcon/jcIcon.png'),
        // act_img: require('@/assets/img/actJcNav.png'),
        path: '/jcNav',
        authId: '',
        data: [
            {
                id: 10099,
                name: "基础",
                path: '/jcNav',
                isNav: true,
                children: [
                    {
                        id: 1009901,
                        path: '/jcNav',
                        name: '基础导航',
                        navTitle: "基础 / 基础导航",
                        // navImg: require('@/assets/img/nav/lsNavIcon/jc/spzl.png'),
                        introduction: "基础导航管理",
                        authId: 'spzl'
                    },
                ]
            },
            {
                id: 10001,
                name: '商品管理',
                children: [

                    {
                        id: 1000101,
                        path: '/pro',
                        name: '商品资料',
                        navTitle: "商品管理 / 商品资料",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/spzl.png'),
                        introduction: "商品资料管理",
                        authId: 'spzl'
                    },
                    {
                        id: 1000102,
                        path: '/productCombo',
                        name: '组合商品',
                        navTitle: "商品管理 / 组合商品",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/zhsp.png'),
                        introduction: "组合商品管理",
                        authId: 'zhsp'
                    },
                    {
                        id: 1000103,
                        path: '/proCls',
                        name: '商品分类',
                        navTitle: "商品管理 / 商品分类",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/spfl.png'),
                        introduction: "商品分类管理",
                        authId: 'spfl'
                    },
                    {
                        id: 1000109,
                        path: '/ppxx',
                        name: '品牌信息',
                        navTitle: "其他信息 / 品牌信息",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/ppxx.png'),
                        introduction: "品牌信息管理",
                        authId: ''
                    },
                    // {
                    //     id: 1000104,
                    //     path: '/productQuery',
                    //     name: '商品查询',
                    //     navTitle: "商品管理 / 商品查询",
                    //     // navImg: require('@/assets/img/nav/spcx.png'),
                    //     introduction: "商品信息查询",
                    //     authId: 'spcx'
                    // },
                    // {
                    //     id: 1000105,
                    //     path: '/productWeight',
                    //     name: '商品传秤',
                    //     navTitle: "商品管理 / 商品传秤",
                    //     // navImg: require('@/assets/img/nav/spcc.png'),
                    //     introduction: "商品传秤管理",
                    //     authId: 'spcc'
                    // },
                    // {
                    //     id: 1000106,
                    //     path: '/priceTagPrint',
                    //     name: '价签打印',
                    //     navTitle: "商品管理 / 价签打印",
                    //     // navImg: require('@/assets/img/nav/jqdyp.png'),
                    //     introduction: "商品价签打印",
                    //     authId: 'jqdyp'
                    // },
                    // {
                    //     id: 1000107,
                    //     path: '/productPriceAdjust',
                    //     name: '商品调价',
                    //     navTitle: "商品管理 / 商品调价",
                    //     // navImg: require('@/assets/img/nav/sptj.png'),
                    //     introduction: "商品价格调整",
                    //     authId: 'sptj'
                    // },
                    // {
                    //     id: 1000108,
                    //     path: '/costPriceAdjust',
                    //     name: '调成本价',
                    //     navTitle: "商品管理 / 调成本价",
                    //     // navImg: require('@/assets/img/nav/tcbj.png'),
                    //     introduction: "调整商品成本价",
                    //     authId: 'tcbj'
                    // }
                ]
            },
            {
                id: 10002,
                name: '门店管理',
                children: [
                    {
                        id: 1000201,
                        path: '/mall',
                        name: '门店资料',
                        navTitle: "门店管理 / 门店资料",
                        navImg: require('@/assets/img/nav/mdxx.png'),
                        introduction: "门店资料管理",
                        authId: 'mdzl'
                    },
                    {
                        id: 1000202,
                        path: '/mallCls',
                        name: '门店区域',
                        navTitle: "门店管理 / 门店区域",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/mdqy.png'),
                        introduction: "门店区域管理",
                        authId: 'mdqy'
                    },
                    // {
                    //     id: 1000203,
                    //     path: '/storeProduct',
                    //     name: '门店商品',
                    //     navTitle: "门店管理 / 门店商品",
                    //     // navImg: require('@/assets/img/nav/mdsp.png'),
                    //     introduction: "门店商品管理",
                    //     authId: 'mdsp'
                    // },
                    {
                        id: 1000204,
                        path: '/user',
                        name: '员工信息',
                        navTitle: "门店管理 / 员工信息",
                        navImg: require('@/assets/img/nav/ygxx.png'),
                        introduction: "员工信息管理",
                        authId: 'yggl'
                    },
                    {
                        id: 1000205,
                        path: '/userCls',
                        name: '员工分组',
                        navTitle: "门店管理 / 员工分组",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/ygfz.png'),
                        introduction: "员工分组管理",
                        authId: 'yfgz'
                    },
                    {
                        id: 1000206,
                        path: '/userPower',
                        name: '员工权限',
                        navTitle: "门店管理 / 员工权限",
                        navImg: require('@/assets/img/nav/ygqx.png'),
                        introduction: "为角色分配所需权限",
                        authId: 'yfgx'
                    },
                    // {
                    //     id: 1000207,
                    //     path: '/storeEmployee',
                    //     name: '门店员工',
                    //     navTitle: "门店管理 / 门店员工",
                    //     // navImg: require('@/assets/img/nav/mdyg.png'),
                    //     introduction: "门店员工管理",
                    //     authId: 'mdyg'
                    // }
                ]
            },
            {
                id: 10003,
                name: '资金账户',
                children: [
                    {
                        id: 1000305,
                        path: '/amtAcct',
                        name: '资金账户',
                        navTitle: "资金账户 / 资金账户",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/zjzh.png'),
                        introduction: "资金账户管理",
                        authId: ''
                    },
                    {
                        id: 1000301,
                        path: '/acct',
                        name: '收款方式',
                        navTitle: "资金账户 / 收款方式",
                        navImg: require('@/assets/img/nav/skzh.png'),
                        introduction: "收款方式管理",
                        authId: 'skfs'
                    },

                    {
                        id: 1000302,
                        path: '/zjls',
                        name: '资金流水',
                        navTitle: "资金账户 / 资金流水",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/zjls.png'),
                        introduction: "资金流水管理",
                        authId: ''
                    },
                    {
                        id: 1000303,
                        path: '/fyxm',
                        name: '费用项目',
                        navTitle: "资金账户 / 费用项目",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/fyxm.png'),
                        introduction: "费用项目管理",
                        authId: 'fyxm'
                    },
                    {
                        id: 1000304,
                        path: '/fysz',
                        name: '费用收支',
                        navTitle: "资金账户 / 费用收支",
                        navImg: require('@/assets/img/nav/lsNavIcon/jc/fysz.png'),
                        introduction: "费用收支管理",
                        authId: 'fysh'
                    }
                ]
            },
            {
                id: 10004,
                name: '其他信息',
                children: [
                    {
                        id: 1000401,
                        path: '/unit',
                        name: '单位信息',
                        navTitle: "其他信息 / 单位信息",
                        navImg: require('@/assets/img/nav/jlxx.png'),
                        introduction: "单位信息管理",
                        authId: 'dwxx'
                    },

                    {
                        id: 1000403,
                        path: '/remark',
                        name: '常用备注',
                        navTitle: "其他信息 / 常用备注",
                        navImg: require('@/assets/img/nav/cybz.png'),
                        introduction: "常用备注管理",
                        authId: 'cybz'
                    }
                ]
            }
        ]
    },

    // 零售模块
    {
        id: 20,
        name: "零售",
        img: require('@/assets/img//nav/lsNavIcon/lsouIcon.png'),

        // act_img: require('@/assets/img/actLsNav.png'),
        path: '/lsNav',
        authId: '',
        data: [
            {
                id: 20099,
                path: '/lsNav',
                name: '零售',
                isNav: true,
                children: [
                    {
                        id: 2009901,
                        path: '/lsNav',
                        name: '基础导航',
                        navTitle: "零售 / 基础导航",
                        // navImg: require('@/assets/img/nav/spzl.png'),
                        introduction: "基础导航管理",
                        authId: 'spzl'
                    },
                ]
            },
            {
                id: 20001,
                name: '会员管理',
                children: [
                    {
                        id: 2000101,
                        path: '/vip',
                        name: '会员资料',
                        navTitle: "会员管理 / 会员资料",
                        navImg: require('@/assets/img/nav/hyxx.png'),
                        introduction: "会员资料管理",
                        authId: 'hyzl'
                    },
                    {
                        id: 2000102,
                        path: '/vipCls',
                        name: '会员等级',
                        navTitle: "会员管理 / 会员等级",
                        navImg: require('@/assets/img/nav/hydj.png'),
                        introduction: "会员等级管理",
                        authId: 'hydj'
                    },
                    // {
                    //     id: 2000103,
                    //     path: '/memberGroup',
                    //     name: '会员分群',
                    //     navTitle: "会员管理 / 会员分群",
                    //     // navImg: require('@/assets/img/nav/hyfq.png'),
                    //     introduction: "会员分群管理",
                    //     authId: 'hyfq'
                    // },
                    // {
                    //     id: 2000104,
                    //     path: '/memberTag',
                    //     name: '会员标签',
                    //     navTitle: "会员管理 / 会员标签",
                    //     // navImg: require('@/assets/img/nav/hytb.png'),
                    //     introduction: "会员标签管理",
                    //     authId: 'hytb'
                    // },
                    {
                        id: 2000105,
                        path: '/vipCzFa',
                        name: '充值方案',
                        navTitle: "会员管理 / 充值方案",
                        navImg: require('@/assets/img/nav/czfa.png'),
                        introduction: "充值方案管理",
                        authId: 'czfa'
                    },
                    {
                        id: 2000106,
                        path: '/vipJf',
                        name: '积分规则',
                        navTitle: "会员管理 / 积分规则",
                        navImg: require('@/assets/img/nav/lsNavIcon/ls/jfgz.png'),

                        introduction: "积分规则设置",
                        authId: 'jfgz'
                    },
                    // {
                    //     id: 2000107,
                    //     path: '/pointsExchange',
                    //     name: '积分兑换',
                    //     navTitle: "会员管理 / 积分兑换",
                    //     // navImg: require('@/assets/img/nav/jfdh.png'),
                    //     introduction: "积分兑换管理",
                    //     authId: 'jfdh'
                    // },
                    // {
                    //     id: 2000108,
                    //     path: '/memberArrears',
                    //     name: '会员欠款',
                    //     navTitle: "会员管理 / 会员欠款",
                    //     // navImg: require('@/assets/img/nav/hyqk.png'),
                    //     introduction: "会员欠款管理",
                    //     authId: 'hyqk'
                    // }
                ]
            },
            // {
            //     id: 20002,
            //     name: '卡券管理',
            //     children: [
            //         {
            //             id: 2000201,
            //             path: '/cardInfo',
            //             name: '次卡信息',
            //             navTitle: "卡券管理 / 次卡信息",
            //             // navImg: require('@/assets/img/nav/ckxx.png'),
            //             introduction: "次卡信息管理",
            //             authId: 'ckxx'
            //         },
            //         {
            //             id: 2000202,
            //             path: '/couponInfo',
            //             name: '卡券信息',
            //             navTitle: "卡券管理 / 卡券信息",
            //             // navImg: require('@/assets/img/nav/kqxx.png'),
            //             introduction: "卡券信息管理",
            //             authId: 'kqxx'
            //         },
            //         {
            //             id: 2000203,
            //             path: '/giftInfo',
            //             name: '礼包信息',
            //             navTitle: "卡券管理 / 礼包信息",
            //             // navImg: require('@/assets/img/nav/lbxx.png'),
            //             introduction: "礼包信息管理",
            //             authId: 'lbxx'
            //         }
            //     ]
            // },
            {
                id: 20003,
                name: '促销管理',
                children: [
                    {
                        id: 2000301,
                        path: '/cxHz',
                        name: '促销汇总',
                        navTitle: "营销设置 / 促销汇总",
                        navImg: require('@/assets/img/nav/cxhz.png'),
                        introduction: "促销汇总",
                        authId: 'cxHz',
                    },
                    {
                        id: 2000302,
                        path: '/xsTj',
                        name: '限时特价',
                        navTitle: "营销设置 / 限时特价",
                        navImg: require('@/assets/img/nav/xstj.png'),
                        introduction: "设置限时特价商品",
                        authId: 'xstj',
                    },
                    {
                        id: 2000303,
                        path: '/xsZk',
                        name: '限时折扣',
                        navTitle: "营销设置 / 限时折扣",
                        navImg: require('@/assets/img/nav/xszk.png'),
                        introduction: "设置限时打折促销的商品",
                        authId: 'xszk',
                    },
                    {
                        id: 2000304,
                        path: '/mzzk',
                        name: '满折促销',
                        navTitle: "营销设置 / 满折促销",
                        navImg: require('@/assets/img/nav/mzzk.png'),
                        introduction: "购买一定数量/金额享优惠",
                        authId: 'mzzk',
                    },
                    {
                        id: 2000305,
                        path: '/mjcx',
                        name: '满减促销',
                        navTitle: "营销设置 / 满减促销",
                        navImg: require('@/assets/img/nav/mjcx.png'),
                        introduction: "购买一定数量/金额享优惠",
                        authId: 'mjcx',
                    },
                    {
                        id: 2000306,
                        path: '/mzcx',
                        name: '满赠促销',
                        navTitle: "营销设置 / 满赠促销",
                        navImg: require('@/assets/img/nav/mzcx.png'),
                        introduction: "满足门槛后赠送商品或权益",
                        authId: 'mzcx',
                    },
                    {
                        id: 2000307,
                        path: '/mmcx',
                        name: '满免促销',
                        navTitle: "营销设置 / 满免促销",
                        navImg: require('@/assets/img/nav/mmcx.png'),
                        introduction: "满足门槛后免其中一份商品",
                        authId: 'mmcx',
                    },
                    {
                        id: 2000308,
                        path: '/jjg',
                        name: '加价惠购',
                        navTitle: "营销设置 / 加价惠购",
                        navImg: require('@/assets/img/nav/jjg.png'),
                        introduction: "满足门槛后加价换购商品",
                        authId: 'jjg',
                    }
                ]
            },
            {
                id: 20004,
                name: '零售报表',
                children: [
                    {
                        id: 2000401,
                        path: '/jbbb',
                        name: '交班对账',
                        navTitle: "零售报表 / 交班对账",
                        navImg: require('@/assets/img/nav/jbhz.png'),
                        introduction: "交班对账管理",
                        authId: 'jbzd'
                    },
                    {
                        id: 2000402,
                        path: '/lsXsHz',
                        name: '销售汇总',
                        navTitle: "零售报表 / 销售汇总",
                        navImg: require('@/assets/img/nav/xshz.png'),
                        introduction: "销售汇总管理",
                        authId: 'xshz'
                    },
                    {
                        id: 2000403,
                        path: '/lsDj',
                        name: '零售单据',
                        navTitle: "零售报表 / 零售单据",
                        // navImg: require('@/assets/img/nav/djls.png'),
                        navImg: require('@/assets/img/nav/lsNavIcon/ls/lsdj.png'),
                        introduction: "零售单据管理",
                        authId: ''
                    },
                    // {
                    //     id: 2000404,
                    //     path: '/lsMx',
                    //     name: '零售明细',
                    //     navTitle: "零售报表 / 零售明细",
                    //     // navImg: require('@/assets/img/nav/djmx.png'),
                    //     introduction: "零售明细管理",
                    //     authId: ''
                    // },
                    // {
                    //     id: 2000405,
                    //     path: '/abnormalMonitoring',
                    //     name: '异常监控',
                    //     navTitle: "零售报表 / 异常监控",
                    //     // navImg: require('@/assets/img/nav/ycck.png'),
                    //     introduction: "异常监控管理",
                    //     authId: 'ycck'
                    // },
                    // {
                    //     id: 2000406,
                    //     path: '/productDetail',
                    //     name: '商品明细',
                    //     navTitle: "零售报表 / 商品明细",
                    //     // navImg: require('@/assets/img/nav/spmx.png'),
                    //     introduction: "商品明细管理",
                    //     authId: 'spmx'
                    // }
                ]
            },
            {
                id: 20005,
                name: '会员报表',
                children: [
                    // {
                    //     id: 2000501,
                    //     path: '/consumptionSummary',
                    //     name: '消费汇总',
                    //     navTitle: "会员报表 / 消费汇总",
                    //     // navImg: require('@/assets/img/nav/xfhz.png'),
                    //     introduction: "消费汇总管理",
                    //     authId: 'xfhz'
                    // },
                    // {
                    //     id: 2000502,
                    //     path: '/consumptionDetail',
                    //     name: '消费明细',
                    //     navTitle: "会员报表 / 消费明细",
                    //     // navImg: require('@/assets/img/nav/xfmx.png'),
                    //     introduction: "消费明细管理",
                    //     authId: 'xfmx'
                    // },
                    {
                        id: 2000503,
                        path: '/yeMx',
                        name: '余额明细',
                        navTitle: "会员报表 / 余额明细",
                        navImg: require('@/assets/img/nav/yemx.png'),
                        introduction: "余额明细管理",
                        authId: 'yemx'
                    },
                    {
                        id: 2000504,
                        path: '/jfMx',
                        name: '积分明细',
                        navTitle: "会员报表 / 积分明细",
                        navImg: require('@/assets/img/nav/jfmx.png'),
                        introduction: "积分明细管理",
                        authId: 'jfmx'
                    },
                    // {
                    //     id: 2000505,
                    //     path: '/depositDetail',
                    //     name: '寄存明细',
                    //     navTitle: "会员报表 / 寄存明细",
                    //     // navImg: require('@/assets/img/nav/jcmx.png'),
                    //     introduction: "寄存明细管理",
                    //     authId: 'jcmx'
                    // },
                    // {
                    //     id: 2000506,
                    //     path: '/couponReport',
                    //     name: '卡券报表',
                    //     navTitle: "会员报表 / 卡券报表",
                    //     // navImg: require('@/assets/img/nav/kqbb.png'),
                    //     introduction: "卡券报表管理",
                    //     authId: 'kqbb'
                    // },
                    // {
                    //     id: 2000507,
                    //     path: '/cardReport',
                    //     name: '次卡报表',
                    //     navTitle: "会员报表 / 次卡报表",
                    //     // navImg: require('@/assets/img/nav/ckbb.png'),
                    //     introduction: "次卡报表管理",
                    //     authId: 'ckbb'
                    // },
                    // {
                    //     id: 2000508,
                    //     path: '/giftReport',
                    //     name: '礼包报表',
                    //     navTitle: "会员报表 / 礼包报表",
                    //     // navImg: require('@/assets/img/nav/lbxx.png'),
                    //     introduction: "礼包报表管理",
                    //     authId: 'lbxx'
                    // },
                    // {
                    //     id: 2000509,
                    //     path: '/cardSaleDetail',
                    //     name: '售卡明细',
                    //     navTitle: "会员报表 / 售卡明细",
                    //     // navImg: require('@/assets/img/nav/skmx.png'),
                    //     introduction: "售卡明细管理",
                    //     authId: 'skmx'
                    // }
                ]
            },
            // {
            //     id: 20006,
            //     name: '商城管理',
            //     children: []
            // }
        ]
    },


    // 采购模块
    {
        id: 60,
        name: "采购",
        img: require('@/assets/img//nav/lsNavIcon/cgIcon.png'),

        path: '/cgNav',
        authId: '',
        data: [
            {
                id: 60099,
                path: '/cgNav',
                name: '采购',
                isNav: true,
                children: [
                    {
                        id: 6009901,
                        path: '/cgNav',
                        name: '基础导航',
                        navTitle: "采购 / 基础导航",
                        // navImg: require('@/assets/img/nav/spzl.png'),
                        introduction: "基础导航管理",
                        authId: ''
                    },
                ]
            },
            {
                id: 60001,
                name: '货商管理',
                children: [
                    {
                        id: 6000101,
                        path: '/hsda',
                        name: '货商档案',
                        navTitle: "货商管理 / 货商档案",
                        introduction: "货商档案管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/hsda.png'),
                        authId: 'hstd'
                    },
                    {
                        id: 6000102,
                        path: '/hsfl',
                        name: '货商分类',
                        navTitle: "货商管理 / 货商分类",
                        introduction: "货商分类管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/hsfl.png'),
                        authId: 'hstf'
                    },
                    // {
                    //     id: 6000103,
                    //     path: '/purchaseContract',
                    //     name: '采购合同',
                    //     navTitle: "货商管理 / 采购合同",
                    //     introduction: "采购合同管理",
                    //     authId: 'cght'
                    // },
                    {
                        id: 6000104,
                        path: '/hsjg',
                        name: '货商价格',
                        navTitle: "货商管理 / 货商价格",
                        introduction: "货商价格管理",
                        authId: ''
                    }
                ]
            },
            {
                id: 60002,
                name: '采购管理',
                children: [
                    // {
                    //     id: 6000201,
                    //     path: '/purchaseOrder',
                    //     name: '采购订货',
                    //     navTitle: "采购管理 / 采购订货",
                    //     introduction: "采购订货管理",
                    //     authId: 'cgdh'
                    // },
                    {
                        id: 6000202,
                        path: '/cgrk',
                        name: '采购入库',
                        navTitle: "采购管理 / 采购入库",
                        introduction: "采购入库管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/cgrk.png'),
                        authId: ''
                    },
                    {
                        id: 6000203,
                        path: '/cgth',
                        name: '采购退货',
                        navTitle: "采购管理 / 采购退货",
                        introduction: "采购退货管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/cgth.png'),
                        authId: ''
                    },
                     {
                        id: 6000205,
                        path: '/cgSz',
                        name: '采购设置',
                        navTitle: "采购管理 / 采购设置",
                        introduction: "采购设置管理",
                        // navImg: require('@/assets/img/nav/lsNavIcon/cg/cgth.png'),
                        authId: ''
                    },
                    // {
                    //     id: 6000204,
                    //     path: '/replenishApply',
                    //     name: '补货申请',
                    //     navTitle: "采购管理 / 补货申请",
                    //     introduction: "补货申请管理",
                    //     authId: 'bhsq'
                    // }
                ]
            },
            {
                id: 60003,
                name: '采购报表',
                children: [
                    {
                        id: 6000301,
                        path: '/cgdj',
                        name: '采购单据',
                        navTitle: "采购报表 / 采购单据",
                        introduction: "采购单据管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/cgdj.png'),
                        authId: ''
                    },
                    // {
                    //     id: 6000302,
                    //     path: '/purchaseDetail',
                    //     name: '采购明细',
                    //     navTitle: "采购报表 / 采购明细",
                    //     introduction: "采购明细管理",
                    //     authId: 'cgmx'
                    // },
                    {
                        id: 6000303,
                        path: '/cgHz',
                        name: '采购汇总',
                        navTitle: "采购报表 / 采购汇总",
                        introduction: "采购汇总管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/cg/cghz.png'),
                        authId: ''
                    },
                    // {
                    //     id: 6000304,
                    //     path: '/dhHz',
                    //     name: '订货汇总',
                    //     navTitle: "采购报表 / 订货汇总",
                    //     introduction: "订货汇总管理",
                    //     navImg: require('@/assets/img/nav/lsNavIcon/cg/dhHz.png'),
                    //     authId: ''
                    // }
                ]
            },
            {
                id: 60004,
                name: '费用结算',
                children: [
                    // {
                    //     id: 6000401,
                    //     path: '/hsfy',
                    //     name: '货商费用',
                    //     navTitle: "费用结算 / 货商费用",
                    //     introduction: "货商费用管理",
                    //     authId: 'hsfy'
                    // },
                    {
                        id: 6000402,
                        path: '/hsjs',
                        name: '货商结算',
                        navTitle: "费用结算 / 货商结算",
                        introduction: "货商结算管理",
                        authId: 'hsjs'
                    },
                    // {
                    //     id: 6000403,
                    //     path: '/supplierPrepay',
                    //     name: '货商预付',
                    //     navTitle: "费用结算 / 货商预付",
                    //     introduction: "货商预付管理",
                    //     authId: 'hsyf'
                    // },
                    // {
                    //     id: 6000404,
                    //     path: '/hsYfLs',
                    //     name: '应付流水',
                    //     navTitle: "费用结算 / 应付流水",
                    //     introduction: "应付流水管理",
                    //     authId: 'yfsl'
                    // }
                ]
            }
        ]
    },
    // 批发模块
    {
        id: 61,
        name: "批发",
        img: require('@/assets/img//nav/lsNavIcon/pfIcon.png'),

        path: '/pfNav',
        authId: '',
        data: [
            {
                id: 61099,
                path: '/pfNav',
                name: '批发',
                isNav: true,
                children: [
                    {
                        id: 6109901,
                        path: '/pfNav',
                        name: '基础导航',
                        navTitle: "批发 / 基础导航",
                        // navImg: require('@/assets/img/nav/spzl.png'),
                        introduction: "基础导航管理",
                        authId: ''
                    },
                ]
            },
            {
                id: 61001,
                name: '客户管理',
                children: [
                    {
                        id: 6100101,
                        path: '/khda',
                        name: '客户档案',
                        navTitle: "客户管理 / 客户档案",
                        introduction: "客户档案管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/pf/khda.png'),
                        authId: ''
                    },
                    {
                        id: 6100102,
                        path: '/khfl',
                        name: '客户分类',
                        navTitle: "客户管理 / 客户分类",
                        introduction: "客户分类管理",
                        navImg: require('@/assets/img/nav/lsNavIcon/pf/khfl.png'),
                        authId: ''
                    },
                    // {
                    //     id: 6100103,
                    //     path: '/salesContract',
                    //     name: '销售合同',
                    //     navTitle: "客户管理 / 销售合同",
                    //     introduction: "销售合同管理",
                    //     authId: 'xshh'
                    // },
                    // {
                    //     id: 6100104,
                    //     path: '/customerPrice',
                    //     name: '客户价格',
                    //     navTitle: "客户管理 / 客户价格",
                    //     introduction: "客户价格管理",
                    //     authId: 'khjg'
                    // }
                ]
            },
            // {
            //     id: 61002,
            //     name: '批发管理',
            //     children: [
            //         {
            //             id: 6100201,
            //             path: '/wholesaleOrder',
            //             name: '批发订单',
            //             navTitle: "批发管理 / 批发订单",
            //             introduction: "批发订单管理",
            //             authId: 'pfdh'
            //         },
            //         {
            //             id: 6100202,
            //             path: '/wholesaleOutstock',
            //             name: '批发出库',
            //             navTitle: "批发管理 / 批发出库",
            //             introduction: "批发出库管理",
            //             authId: 'pfck'
            //         },
            //         {
            //             id: 6100203,
            //             path: '/wholesaleReturn',
            //             name: '批发退货',
            //             navTitle: "批发管理 / 批发退货",
            //             introduction: "批发退货管理",
            //             authId: 'pfth'
            //         }
            //     ]
            // },
            // {
            //     id: 61003,
            //     name: '批发报表',
            //     children: [
            //         {
            //             id: 6100301,
            //             path: '/wholesaleDoc',
            //             name: '批发单据',
            //             navTitle: "批发报表 / 批发单据",
            //             introduction: "批发单据管理",
            //             authId: 'pfdj'
            //         },
            //         {
            //             id: 6100302,
            //             path: '/wholesaleDetail',
            //             name: '批发明细',
            //             navTitle: "批发报表 / 批发明细",
            //             introduction: "批发明细管理",
            //             authId: 'pfmx'
            //         },
            //         {
            //             id: 6100303,
            //             path: '/wholesaleSummary',
            //             name: '批发汇总',
            //             navTitle: "批发报表 / 批发汇总",
            //             introduction: "批发汇总管理",
            //             authId: 'pfhz'
            //         },
            //         {
            //             id: 6100304,
            //             path: '/wholesaleOrderSummary',
            //             name: '订单汇总',
            //             navTitle: "批发报表 / 订单汇总",
            //             introduction: "订单汇总管理",
            //             authId: 'ddhz'
            //         },
            //         {
            //             id: 6100305,
            //             path: '/wholesaleSalesAnalysis',
            //             name: '销售分析',
            //             navTitle: "批发报表 / 销售分析",
            //             introduction: "销售分析管理",
            //             authId: 'xsfx'
            //         }
            //     ]
            // },
            // {
            //     id: 61004,
            //     name: '费用结算',
            //     children: [
            //         {
            //             id: 6100401,
            //             path: '/customerFee',
            //             name: '客户费用',
            //             navTitle: "费用结算 / 客户费用",
            //             introduction: "客户费用管理",
            //             authId: 'khfy'
            //         },
            //         {
            //             id: 6100402,
            //             path: '/customerSettlement',
            //             name: '客户结算',
            //             navTitle: "费用结算 / 客户结算",
            //             introduction: "客户结算管理",
            //             authId: 'khjs'
            //         },
            //         {
            //             id: 6100403,
            //             path: '/customerPrepay',
            //             name: '客户预付',
            //             navTitle: "费用结算 / 客户预付",
            //             introduction: "客户预付管理",
            //             authId: 'khyf'
            //         },
            //         {
            //             id: 6100404,
            //             path: '/receivableFlow',
            //             name: '应收流水',
            //             navTitle: "费用结算 / 应收流水",
            //             introduction: "应收流水管理",
            //             authId: 'yssl'
            //         }
            //     ]
            // }
        ]
    },
    // 库存模块
    {
        id: 70,
        name: "库存",
        img: require('@/assets/img//nav/lsNavIcon/kcIcon.png'),
        path: '/kcNav',
        authId: '',
        data: [
            {
                id: 70099,
                path: '/kcNav',
                name: "库存",

                isNav: true,
                children: [
                    {
                        id: 7009901,
                        path: '/kcNav',
                        name: '库存导航',
                        navTitle: "库存 / 库存导航",
                        introduction: "库存导航管理",
                    },
                ]
            },
            // {
            //     id: 70001,
            //     name: '库存盘点',
            //     children: [
            //         {
            //             id: 7000101,
            //             path: '/inventoryCount',
            //             name: '库存盘点',
            //             navTitle: "库存盘点 / 库存盘点",
            //             introduction: "库存盘点管理",
            //             authId: 'kcpd'
            //         },
            //         {
            //             id: 7000102,
            //             path: '/inventoryDoc',
            //             name: '盘点单据',
            //             navTitle: "库存盘点 / 盘点单据",
            //             introduction: "盘点单据管理",
            //             authId: 'pddj'
            //         },
            //         {
            //             id: 7000103,
            //             path: '/inventoryDetail',
            //             name: '盘点明细',
            //             navTitle: "库存盘点 / 盘点明细",
            //             introduction: "盘点明细管理",
            //             authId: 'pdmx'
            //         },
            //         {
            //             id: 7000104,
            //             path: '/inventorySummary',
            //             name: '盘点汇总',
            //             navTitle: "库存盘点 / 盘点汇总",
            //             introduction: "盘点汇总管理",
            //             authId: 'pdhz'
            //         }
            //     ]
            // },
            // {
            //     id: 70002,
            //     name: '库存报损',
            //     children: [
            //         {
            //             id: 7000201,
            //             path: '/productLoss',
            //             name: '商品报损',
            //             navTitle: "库存报损 / 商品报损",
            //             introduction: "商品报损管理",
            //             authId: 'spbs'
            //         },
            //         {
            //             id: 7000202,
            //             path: '/lossDoc',
            //             name: '报损单据',
            //             navTitle: "库存报损 / 报损单据",
            //             introduction: "报损单据管理",
            //             authId: 'bsdj'
            //         },
            //         {
            //             id: 7000203,
            //             path: '/lossDetail',
            //             name: '报损明细',
            //             navTitle: "库存报损 / 报损明细",
            //             introduction: "报损明细管理",
            //             authId: 'bsmx'
            //         },
            //         {
            //             id: 7000204,
            //             path: '/lossSummary',
            //             name: '报损汇总',
            //             navTitle: "库存报损 / 报损汇总",
            //             introduction: "报损汇总管理",
            //             authId: 'bshz'
            //         }
            //     ]
            // },
            {
                id: 70003,
                name: '库存报表',
                children: [
                    {
                        id: 7000301,
                        path: '/kccx',
                        name: '库存查询',
                        navTitle: "库存报表 / 库存查询",
                        introduction: "库存查询",
                        authId: ''
                    },
                    // {
                    //     id: 7000302,
                    //     path: '/inventoryAlert',
                    //     name: '库存预警',
                    //     navTitle: "库存报表 / 库存预警",
                    //     introduction: "库存预警管理",
                    //     authId: 'kcjj'
                    // },
                    // {
                    //     id: 7000303,
                    //     path: '/productAge',
                    //     name: '商品库龄',
                    //     navTitle: "库存报表 / 商品库龄",
                    //     introduction: "商品库龄管理",
                    //     authId: 'spkl'
                    // }
                ]
            }
        ]
    },
    // 连锁模块
    // {
    //     id: 80,
    //     name: "连锁",
    //     img: require('@/assets/img//nav/lsNavIcon/lsNav.png'),
    //     path: '/lsNav',
    //     authId: '',
    //     data: [
    //         {
    //             id: 80001,
    //             name: '要货申请',
    //             children: [
    //                 {
    //                     id: 8000101,
    //                     path: '/goodsReqApply',
    //                     name: '要货申请',
    //                     navTitle: "要货申请 / 要货申请",
    //                     introduction: "要货申请管理",
    //                     authId: 'yhsq'
    //                 },
    //                 {
    //                     id: 8000102,
    //                     path: '/goodsReqDoc',
    //                     name: '要货单据',
    //                     navTitle: "要货申请 / 要货单据",
    //                     introduction: "要货单据管理",
    //                     authId: 'yhdj'
    //                 },
    //                 {
    //                     id: 8000103,
    //                     path: '/goodsReqDetail',
    //                     name: '要货明细',
    //                     navTitle: "要货申请 / 要货明细",
    //                     introduction: "要货明细管理",
    //                     authId: 'yhmx'
    //                 },
    //                 {
    //                     id: 8000104,
    //                     path: '/goodsReqSummary',
    //                     name: '要货汇总',
    //                     navTitle: "要货申请 / 要货汇总",
    //                     introduction: "要货汇总管理",
    //                     authId: 'yhzz'
    //                 }
    //             ]
    //         },
    //         {
    //             id: 80002,
    //             name: '门店调拨',
    //             children: [
    //                 {
    //                     id: 8000201,
    //                     path: '/storeDirectTransfer',
    //                     name: '门店直调',
    //                     navTitle: "门店调拨 / 门店直调",
    //                     introduction: "门店直调管理",
    //                     authId: 'mdzt'
    //                 },
    //                 {
    //                     id: 8000202,
    //                     path: '/storePrice',
    //                     name: '门店价格',
    //                     navTitle: "门店调拨 / 门店价格",
    //                     introduction: "门店价格管理",
    //                     authId: 'mdjg'
    //                 },
    //                 {
    //                     id: 8000203,
    //                     path: '/transferDoc',
    //                     name: '调拨单据',
    //                     navTitle: "门店调拨 / 调拨单据",
    //                     introduction: "调拨单据管理",
    //                     authId: 'dbdj'
    //                 },
    //                 {
    //                     id: 8000204,
    //                     path: '/transferDetail',
    //                     name: '调拨明细',
    //                     navTitle: "门店调拨 / 调拨明细",
    //                     introduction: "调拨明细管理",
    //                     authId: 'dbmx'
    //                 },
    //                 {
    //                     id: 8000205,
    //                     path: '/transferSummary',
    //                     name: '调拨汇总',
    //                     navTitle: "门店调拨 / 调拨汇总",
    //                     introduction: "调拨汇总管理",
    //                     authId: 'dbhz'
    //                 },
    //                 {
    //                     id: 8000206,
    //                     path: '/transferAnalysis',
    //                     name: '调拨分析',
    //                     navTitle: "门店调拨 / 调拨分析",
    //                     introduction: "调拨分析管理",
    //                     authId: 'dbfx'
    //                 }
    //             ]
    //         },
    //         {
    //             id: 80003,
    //             name: '费用结算',
    //             children: [
    //                 {
    //                     id: 8000301,
    //                     path: '/storeFee',
    //                     name: '门店费用',
    //                     navTitle: "费用结算 / 门店费用",
    //                     introduction: "门店费用管理",
    //                     authId: 'mdfy'
    //                 },
    //                 {
    //                     id: 8000302,
    //                     path: '/storeSettlement',
    //                     name: '门店结算',
    //                     navTitle: "费用结算 / 门店结算",
    //                     introduction: "门店结算管理",
    //                     authId: 'mdjs'
    //                 },
    //                 {
    //                     id: 8000303,
    //                     path: '/storePrepay',
    //                     name: '门店预付',
    //                     navTitle: "费用结算 / 门店预付",
    //                     introduction: "门店预付管理",
    //                     authId: 'mdyf'
    //                 },
    //                 {
    //                     id: 8000304,
    //                     path: '/settlementFlow',
    //                     name: '结算流水',
    //                     navTitle: "费用结算 / 结算流水",
    //                     introduction: "结算流水管理",
    //                     authId: 'jsls'
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // 决策模块
    // {
    //     id: 90,
    //     name: "决策",
    //     path: '/jcNav',
    //     authId: '',
    //     data: [
    //         {
    //             id: 90001,
    //             name: '商品销售',
    //             children: [
    //                 {
    //                     id: 9000101,
    //                     path: '/salesSummary',
    //                     name: '销售汇总',
    //                     navTitle: "商品销售 / 销售汇总",
    //                     introduction: "销售汇总管理",
    //                     authId: 'xshz'
    //                 },
    //                 {
    //                     id: 9000102,
    //                     path: '/salesDaily',
    //                     name: '销售日报',
    //                     navTitle: "商品销售 / 销售日报",
    //                     introduction: "销售日报管理",
    //                     authId: 'xsrb'
    //                 },
    //                 {
    //                     id: 9000103,
    //                     path: '/salesRanking',
    //                     name: '销售排行',
    //                     navTitle: "商品销售 / 销售排行",
    //                     introduction: "销售排行管理",
    //                     authId: 'xsph'
    //                 },
    //                 {
    //                     id: 9000104,
    //                     path: '/salesCompare',
    //                     name: '销售对比',
    //                     navTitle: "商品销售 / 销售对比",
    //                     introduction: "销售对比管理",
    //                     authId: 'xsdb'
    //                 }
    //             ]
    //         },
    //         {
    //             id: 90002,
    //             name: '营业分析',
    //             children: [
    //                 {
    //                     id: 9000201,
    //                     path: '/storeSales',
    //                     name: '门店销售',
    //                     navTitle: "营业分析 / 门店销售",
    //                     introduction: "门店销售分析",
    //                     authId: 'mdxs'
    //                 },
    //                 {
    //                     id: 9000202,
    //                     path: '/storeDailyReport',
    //                     name: '门店日报',
    //                     navTitle: "营业分析 / 门店日报",
    //                     introduction: "门店日报分析",
    //                     authId: 'mdrb'
    //                 },
    //                 {
    //                     id: 9000203,
    //                     path: '/storeMonthlyReport',
    //                     name: '门店月报',
    //                     navTitle: "营业分析 / 门店月报",
    //                     introduction: "门店月报分析",
    //                     authId: 'mdby'
    //                 },
    //                 {
    //                     id: 9000204,
    //                     path: '/customerAnalysis',
    //                     name: '客流分析',
    //                     navTitle: "营业分析 / 客流分析",
    //                     introduction: "客流分析管理",
    //                     authId: 'klfx'
    //                 },
    //                 {
    //                     id: 9000205,
    //                     path: '/grossProfitAnalysis',
    //                     name: '毛利分析',
    //                     navTitle: "营业分析 / 毛利分析",
    //                     introduction: "毛利分析管理",
    //                     authId: 'molfx'
    //                 }
    //             ]
    //         }
    //     ]
    // },
    // 系统模块
    {
        id: 99,
        name: "系统",
        img: require('@/assets/img//nav/lsNavIcon/xtIcon.png'),
        // act_img: require('@/assets/img/actSetNav.png'),
        path: '/xtNav',
        authId: '',
        data: [
            {
                id: 99099,
                name: '系统',
                path: '/szNav',
                isNav: true,
                children: [
                    {
                        id: 9909901,
                        path: '/szNav',
                        name: '系统导航',
                        navTitle: "系统 / 系统导航",
                        introduction: "系统导航管理",
                    },
                ]
            },
            {
                id: 99001,
                name: '系统管理',
                children: [
                    // {
                    //     id: 9900101,
                    //     path: '/subscreenAd',
                    //     name: '副屏广告',
                    //     navTitle: "系统管理 / 副屏广告",
                    //     introduction: "副屏广告管理",
                    //     authId: 'fpsg'
                    // },
                    // {
                    //     id: 9900102,
                    //     path: '/systemParams',
                    //     name: '系统参数',
                    //     navTitle: "系统管理 / 系统参数",
                    //     introduction: "系统参数设置",
                    //     authId: 'xtcs'
                    // },
                    // {
                    //     id: 9900103,
                    //     path: '/dataMaintenance',
                    //     name: '数据维护',
                    //     navTitle: "系统管理 / 数据维护",
                    //     introduction: "数据维护管理",
                    //     authId: 'sjwh'
                    // },
                    {
                        id: 9900104,
                        path: '/czrz',
                        name: '操作日志',
                        navTitle: "系统管理 / 操作日志",
                        introduction: "操作日志管理",
                        authId: ''
                    }
                ]
            },
            {
                id: 99002,
                name: '我的信息',
                children: [
                    {
                        id: 9900201,
                        path: '/orgInfo',
                        name: '商户资料',
                        navTitle: "我的信息 / 商户资料",
                        // navImg: require('@/assets/img/nav/jgxx.png'),
                        introduction: "商户资料管理",
                        authId: 'jgxx'
                    },
                    {
                        id: 9900202,
                        path: '/device',
                        name: '设备管理',
                        navTitle: "我的信息 / 设备管理",
                        // navImg: require('@/assets/img/nav/yhz.png'),
                        introduction: "设备管理管理",
                        authId: ''
                    }
                ]
            }
        ]
    }
];

export default lsNavList;


// WEBPACK FOOTER //
// ./src/assets/listData/lsNav.js